import React from 'react';
import './Story.css';

function Story() {
  return (
    <section className="story" id="about">
      <div className="story-inner">
        <span className="section-label reveal">The Origin</span>
        <h2 className="section-title reveal">Built at the Bedside</h2>

        <div className="story-hook reveal">
          <p className="lead">
            What happens when a biochemist watches neurochemistry operate in real
            time&mdash;through medications, behavior, recovery, relapse, and the
            countless small decisions that shape human outcomes?
          </p>
          <p>
            They build <strong>AETHER</strong>: Adaptive Endocrine Transformer Heads
            with Emotional Regulation.
          </p>
          <p>
            AETHER is a transformer architecture inspired by biological systems. The
            same pharmacokinetic principles that govern how drugs are absorbed,
            distributed, metabolized, and eliminated also govern how the model
            assigns significance to experience over time.
          </p>
          <p>Most AI systems optimize for prediction.</p>
          <p>AETHER was designed to <strong>model persistence</strong>.</p>
          <p>
            Not every experience should matter forever. Not every experience should
            be forgotten immediately. Biological systems solve this problem through
            decay, reinforcement, and competing signals. AETHER applies similar
            principles to memory weighting and internal state.
          </p>
          <p>
            The result is a simulation architecture designed to explore how state,
            experience, and time interact within complex systems.
          </p>
          <p>
            The long-term objective is <strong>not another chatbot</strong>. It is
            the creation of simulation environments capable of generating structured
            synthetic data for research, development, and future in silico
            experimentation.
          </p>
        </div>
      </div>
    </section>
  );
}

export default Story;
